import { render, staticRenderFns } from "./LandingCreatorsButton.vue?vue&type=template&id=3ab8e84c&scoped=true&"
import script from "./LandingCreatorsButton.vue?vue&type=script&lang=ts&"
export * from "./LandingCreatorsButton.vue?vue&type=script&lang=ts&"
import style0 from "./LandingCreatorsButton.vue?vue&type=style&index=0&id=3ab8e84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab8e84c",
  null
  
)

export default component.exports